module.exports = __webpack_public_path__ + "background1.jpg";